import ipadcase from '../../assets/muvtech/Muvdata/ipadCases/Defense11-11pro.png';
import ipadcase2 from '../../assets/muvtech/Muvdata/ipadCases/Rotator11-pro.png';
import ipadcase3 from '../../assets/muvtech/Muvdata/ipadCases/combat11pro11.png';
import ipadcase4 from '../../assets/muvtech/Muvdata/ipadCases/defense13-13pro.png';

const ipadcaseData = [
  {
    id: 1,
    type: 'ipadcase',
    title: 'COMBAT / DEFENSE / ROTATOR',
    compatibleModels: 'iPad Air 11, Pro 11, Pro 13',
    price: 3499,
    specs: [
      'Dual-layer PC + TPU',
      '360° protection',
      'Built-in pen slot',
      'Drop tested (8ft)',
    ],
    image: [ipadcase, ipadcase2, ipadcase3, ipadcase4],
  },
];

export default ipadcaseData;
